//Nginx served the frontend with no Cache-Control header at all until july 2026, so browsers cached
//every file heuristically and stopped asking the server for it. The bundles under /static carry a
//content hash in their name and were never affected, but the files that keep their name across
//deploys -the logo, the translations- got stuck: clients kept showing the previous ones.
//
//The nginx config now revalidates those files on every request, so this token is only here to give
//them a new url once and evict what is already cached. It never has to change again, and it can be
//dropped once no client can still be holding a copy from before that config was deployed.
export const CACHE_BUSTING_TOKEN = '2';
